import { render } from "./LoginV2view.vue?vue&type=template&id=21adb7c6"
import script from "./LoginV2view.vue?vue&type=script&lang=js"
export * from "./LoginV2view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__